<template>
  <div>
    <vue-dropzone
      :include-styling="true"
      v-on:vdropzone-file-added="uploadToggle"
      v-on:vdropzone-removed-file="fileRemoved"
      v-on:vdropzone-canceled="uploadToggle"
      v-on:vdropzone-complete="uploadToggle"
      :awss3="awss3"
      v-on:vdropzone-s3-upload-error="s3UploadError"
      v-on:vdropzone-s3-upload-success="s3UploadSuccess"
      :options="dropzoneOptions"
      ref="vueDropzone"
      id="dropzone"
    ></vue-dropzone>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
const mime = require('mime-types');

export default {
  props: {
    maxFiles: {
      type: Number,
      default: 1,
    },
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      includeStyling: true,
      image_path: null,
      image_url: null,
      uploadInProgress: false,
      awss3: {
        signingURL: process.env.VUE_APP_API_BASE_URI + 's3-sign',
        headers: {
          'client-id': process.env.VUE_APP_API_CLIENT_ID,
          'client-secret': process.env.VUE_APP_API_CLIENT_SECRET,
        },
        params: {},
        sendFileToServer: true,
      },
      dropzoneOptions: {
        dictDefaultMessage: this.$t('Dosyayı yüklemek için tıklayın veya buraya sürükleyin'),
        dictRemoveFile: this.$t('Kaldır'),
        url: 'https://httpbin.org/post',
        thumbnailWidth: 75,
        thumbnailHeight: 75,
        maxFilesize: 5,
        maxFiles: 1,
        acceptedFiles: 'image/*,application/pdf,',
        addRemoveLinks: true,
        dictCancelUpload: this.$t('Kaldır'),
        dictCancelUploadConfirmation: this.$t('Dosyayı kaldırmak istediğinize emin misiniz?'),
        renameFile: function (file) {
          const newName = new Date().getTime() + '_' + file.name;
          return newName;
        },
      },
    };
  },
  methods: {
    s3UploadError(errorMessage) {
      console.log(errorMessage);
    },
    s3UploadSuccess(s3ObjectLocation) {
      const parts = s3ObjectLocation.split('/assets');
      this.image_path = decodeURIComponent('assets' + parts[1]);
      this.image_url = process.env.VUE_APP_CLOUDFRONT_BASE_URL + this.image_path;
      this.$emit('upload', {
        image_path: this.image_path,
        image_url: this.image_url,
      });
    },
    uploadToggle() {
      this.uploadInProgress = !this.uploadInProgress;
      this.$emit('status', this.uploadInProgress);
    },
    fileRemoved(file) {
      if (file.s3ObjectLocation) {
        const parts = file.s3ObjectLocation.split('/assets');
        file.file_path = decodeURIComponent('assets' + parts[1]);
        // eslint-disable-next-line no-template-curly-in-string
        file.file_path = file.file_path.replace('${filename}', file.name);
      }

      this.$emit('fileRemoved', file);
    },
    addFile(file) {
      if (!file) {
        return;
      }

      const properties = {
        size: 123,
        // eslint-disable-next-line no-useless-escape
        name: file.replace(/^.*[\\\/]/, '').slice(11),
        type: mime.lookup(file),
      };

      this.$refs.vueDropzone.manuallyAddFile(properties, process.env.VUE_APP_CLOUDFRONT_BASE_URL + file);
    },
  },
  watch: {
    '$i18n.locale': function () {
      const list = document.getElementsByClassName('dz-default');
      Array.prototype.forEach.call(
        list,
        function (el) {
          el.firstChild.innerHTML = this.$t('Dosyayı yüklemek için tıklayın veya buraya sürükleyin');
        },
        this
      );
      const listRemove = document.getElementsByClassName('dz-remove');
      Array.prototype.forEach.call(
        listRemove,
        function (el) {
          el.innerHTML = this.$t('Kaldır');
        },
        this
      );
    },
  },
  created() {
    this.dropzoneOptions.maxFiles = this.maxFiles;
  },
};
</script>
<style lang="less">
.dropzone {
  .dz-size {
    display: none;
  }

  .dz-remove {
    font-size: 10px !important;
  }

  .dz-preview {
    margin: 0;
  }

  .dz-image img:not([src]) {
    width: 95px !important;
    height: 95px !important;
  }
}
</style>
